module.exports = __webpack_public_path__ + "static/media/play_store.eb5ff08d.png";